import { Link } from "react-router-dom";
import { useEffect } from "react";
import "../assets/css/footer.css";

export default function WebsiteFooter() {
  useEffect(() => {
    const handleScroll = () => {
      const btn = document.querySelector(".back-to-top");
      if (!btn) return;

      if (window.scrollY > 300) {
        btn.classList.add("show");
      } else {
        btn.classList.remove("show");
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <footer className="footer">
        <div className="footer-container">
          <div className="footer-grid">
            <div className="footer-col">
              <h4>Our Office</h4>

              <p>
                <i className="fa fa-map-marker-alt"></i>
                2rd Floor, Wing A, Plot No. 114, Yakubu Gowon Way, Asokoro, Abuja.
              </p>

              <p>
                <i className="fa fa-phone-alt"></i>
                +2349066937455, +2348038278894
              </p>

              <p>
                <i className="fa fa-envelope"></i>
                info@gmttechnologies.com
              </p>

              <div className="footer-socials">
                <a href="#"><i className="fab fa-x-twitter"></i></a>
                <a href="#"><i className="fab fa-facebook-f"></i></a>
                <a href="#"><i className="fab fa-youtube"></i></a>
                <a href="#"><i className="fab fa-linkedin-in"></i></a>
              </div>
            </div>

            <div className="footer-col">
              <h4>Services</h4>
              <Link to="/services">Financial Planning</Link>
              <Link to="/services">Cash Investment</Link>
              <Link to="/services">Financial Consultancy</Link>
              <Link to="/services">Business Loans</Link>
              <Link to="/services">Business Analysis</Link>
            </div>

            <div className="footer-col">
              <h4>Quick Links</h4>
              <Link to="/about">About Us</Link>
              <Link to="/contact">Contact Us</Link>
              <Link to="/services">Our Services</Link>
              <a href="#">Terms & Conditions</a>
              <a href="#">Support</a>
            </div>

            <div className="footer-col">
              <h4>Subscribe to Our Newsletter</h4>
              <p>
                Stay updated with the latest news, insights, and special offers from{" "}
                <strong>GMT Technologies Limited</strong>.
              </p>

              <div className="newsletter-box">
                <input type="email" placeholder="Your email" />
                <button type="button">Sign Up</button>
              </div>
            </div>
          </div>
        </div>
      </footer>

      <div className="copyright">
        <div className="copyright-inner">
          <div>
            &copy; {new Date().getFullYear()}{" "}
            <span>GMT Technologies Limited</span>, All Rights Reserved.
          </div>

          <div>
            Designed By <span>Pelztech</span>
          </div>
        </div>
      </div>

      <a
        href="#"
        onClick={(e) => {
          e.preventDefault();
          window.scrollTo({ top: 0, behavior: "smooth" });
        }}
        className="back-to-top"
      >
        <i className="bi bi-arrow-up"></i>
      </a>
    </>
  );
}